import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-zinc-100 pt-16 pb-8">
      <div className="w-full px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/loadapi-logo.png"
                alt="LoadAPI.io"
                className="h-8 w-auto"
              />
              <span className="text-lg font-bold text-zinc-900">LoadAPI.io</span>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed">
              The unified API for real-time trucking load boards. Connect, filter, and move freight faster.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-zinc-900 mb-4">Product</h4>
            <ul className="space-y-3">
              <li><Link to="/features" className="text-sm text-zinc-500 hover:text-blue-600 transition-colors">Features</Link></li>
              <li><Link to="/" className="text-sm text-zinc-500 hover:text-blue-600 transition-colors">How It Works</Link></li>
              <li><Link to="/join" className="text-sm text-zinc-500 hover:text-blue-600 transition-colors">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-zinc-900 mb-4">Company</h4>
            <ul className="space-y-3">
              <li><span className="text-sm text-zinc-500">About Us</span></li>
              <li><span className="text-sm text-zinc-500">Careers</span></li>
              <li><Link to="/contact" className="text-sm text-zinc-500 hover:text-blue-600 transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-zinc-900 mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><span className="text-sm text-zinc-500">Privacy Policy</span></li>
              <li><span className="text-sm text-zinc-500">Terms of Service</span></li>
              <li><span className="text-sm text-zinc-500">API Terms</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-400">
            &copy; 2026 LoadAPI.io. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-zinc-400 hover:text-zinc-600 transition-colors" aria-label="Twitter">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-twitter-x-line text-lg"></i>
              </div>
            </a>
            <a href="#" rel="nofollow" className="text-zinc-400 hover:text-zinc-600 transition-colors" aria-label="LinkedIn">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-linkedin-box-line text-lg"></i>
              </div>
            </a>
            <a href="#" rel="nofollow" className="text-zinc-400 hover:text-zinc-600 transition-colors" aria-label="GitHub">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-github-line text-lg"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
